import { Observable, timer as observableTimer } from 'rxjs';
// Angular
import { Component, EventEmitter, Input, Output, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NotificationType } from 'libraries/interfaces/INotification';

import { faTimes, IconDefinition } from "@fortawesome/free-solid-svg-icons";

const MESSAGE_SEPARATOR: string = "§§§";

@Component({
    selector: 'notification',
    template: `
        <div class="notification"
             [ngClass]="type"
             [class.inline]="isInline"
             *ngIf="visible">
            <button *ngIf="showCloseButton" class="closeButton" (click)="hide()">
                <fa-icon [icon]="iconTimes"></fa-icon>
            </button>
            <div class="title" *ngIf="title">{{title}}</div>
            <div #message *ngIf="!textLines?.length">
                <ng-content></ng-content>
            </div>
            <ng-container *ngIf="textLines?.length">
                <div *ngFor="let line of textLines">
                    <ng-container *ngIf="isCode">
                        <code>{{line}}</code>
                    </ng-container>
                    <ng-container *ngIf="!isCode">
                        {{line}}
                    </ng-container>
                </div>
            </ng-container>
        </div>`,
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, AfterViewInit {
    @Input()
    public type: NotificationType = NotificationType.Info;

    @Input()
    public autoClose: boolean = false;

    @Input()
    public showCloseButton: boolean = false;

    @Input()
    public closeTimer: number = 2000;
    @Input()
    public isInline: boolean;
    @Input()
    public title: string;
    @Input()
    public isCode: boolean;
    @Input()
    public messageArray: string[];

    @Output()
    public readonly onClose: EventEmitter<boolean> = new EventEmitter();

    @ViewChild('message')
    public message: ElementRef;

    public visible: boolean = true;

    public iconTimes: IconDefinition = faTimes;

    public textLines: string[];

    public ngOnInit(): void {
        if (this.autoClose) {
            this.launchClose();
        }
    }

    public ngAfterViewInit(): void {
        if(this.messageArray?.length){
            this.textLines = this.messageArray;
        }else{
            const messageText: string = this.message?.nativeElement?.innerHTML;
            if (messageText?.includes(MESSAGE_SEPARATOR)) {
                this.textLines = messageText.split(MESSAGE_SEPARATOR);
            }
        }

    }

    public launchClose(): void {
        this.visible = true;
        const timer: Observable<number> = observableTimer(this.closeTimer);
        timer.subscribe((): void => {
            this.hide();
        });
    }

    public hide(): void {
        this.visible = false;
        this.onClose.emit(true);
    }
}
